<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/zazhi">承办杂志</router-link>
    </div>
    <div class="container-width mt50">
      <div class="x-recommend">
        <img class="x-img" :src="firstData.img" />
        <div class="x-introduce">
          <a class="x-title-0">{{ firstData.title }}</a>
          <div class="x-article">
            {{ firstData.introduction }}
          </div>
          <div class="w-more" @click="goArticle(firstData)">查看详情</div>
        </div>
      </div>
      <div class="x-more-title">更多承办杂志</div>
      <ul class="x-list">
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="goArticle(item)"
          v-if="index > 0"
        >
          <img :src="item.img" />

          <a class="mg-title">{{ item.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import config from "../../config/dev";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "ZAZHI",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/zazhi",
      articlePath: "/jxky/zazhi/article",
      pageIndex: 1,
      pageSize: 100,
      totalPages: 1,
      currentPage: 1,
      list: [],
      total: 0,
      firstData: {},
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
      };
      service.getZazhiList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
        this.list = res.content || [];
        this.firstData = { ...this.list[0] };
      });
    },
    goArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/jxky/zazhi/article`,
          query: {
            id: e.id,
          },
        });
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.x-recommend {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
  .x-img {
    width: 350px;
  }
  .x-introduce {
    padding: 50px 50px;

    display: -webkit-flex;
    display: flex;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;

    .x-title-0 {
      font-size: 32px;
    }
    .x-article {
      display: -webkit-flex;
      display: flex;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-justify-content: center;
      justify-content: center;

      flex: 1;
      line-height: 50px;
    }
  }
}
.x-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  row-gap: 30px;
  column-gap: 30px;
  margin-top: 50px;
  li {
    position: relative;
    //width: 232.8px;
    // height: 368.8px;
    // margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      display: block;
      //width: 232.8px; /* 194*1.2 */
      //height: 328.8px; /* 274*1.2 */
      height: 254px;
      -webkit-box-shadow: 4px 4px rgba(85, 85, 85, 0.2);
      -moz-box-shadow: 4px 4px rgba(85, 85, 85, 0.2);
      box-shadow: 4px 4px rgba(85, 85, 85, 0.2);
    }
    img:hover {
      -webkit-box-shadow: 6px 6px rgba(85, 85, 85, 0.4);
      -moz-box-shadow: 6px 6px rgba(85, 85, 85, 0.4);
      box-shadow: 6px 6px rgba(85, 85, 85, 0.4);
    }

    a {
      margin-top: 20px;
      font-size: 1.2rem;
      display: block;
      text-align: center;
      color: #333;
      height: 40px;
    }
    a:hover {
      font-weight: bold;
      color: #00479d;
    }
  }
}
.x-more-title {
  width: 100%;
  background: #00479d;
  text-align: center;
  height: 100px;
  font-size: 28px;
  letter-spacing: 2px;
  color: #ffffff;
  line-height: 100px;
  margin-top: 50px;
}
@media only screen and (max-width: 728px) {
  .x-recommend {
    display: -webkit-flex;
    display: flex;
    background: #ffffff;
    box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;

    -webkit-box-align: center;
    align-items: center;
    .x-img {
      width: 60%;
      margin-top: 15px;
    }
    .x-introduce {
      padding: 15px 15px;
      display: -webkit-flex;
      display: flex;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-justify-content: center;
      justify-content: center;

      -webkit-box-align: center;
      align-items: center;
      .x-title-0 {
        font-size: 1.2rem;
        font-weight: bold;
      }
      .x-article {
        font-size: 1rem;
        line-height: 1.4rem;
      }
    }
  }

  .x-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 15px;
    column-gap: 15px;
    margin-top: 15px;
    li {
      margin-bottom: 0px;
      img {
        width: 90%;
        height: auto;
      }
      a {
        height: 30px;
        font-size: 1.1rem;
      }
    }
  }
  .x-more-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 1.2rem;
    margin-top: 30px;
  }
}
</style>
